import { render, staticRenderFns } from "./MenagesStep.vue?vue&type=template&id=1d709c40"
import script from "./MenagesStep.vue?vue&type=script&lang=js"
export * from "./MenagesStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports